import { render, staticRenderFns } from "./xxtssz_config.vue?vue&type=template&id=49e75ae4&scoped=true&"
import script from "./xxtssz_config.vue?vue&type=script&lang=js&"
export * from "./xxtssz_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e75ae4",
  null
  
)

export default component.exports